import request from '@/router/axios';

const getList = (current, size, params) => request({
  url: '/api/mcc-base/base/templateForm/queryTemplateFormProcess',
  method: 'get',
  params: {
    ...params,
    current,
    size,
  },
})

const detail = params => request({
  url: '/api/mcc-base/base/templateField/detail',
  method: 'get',
  params: {
    ...params,
  },
})

const formDetail = params => request({
  url: '/api/mcc-base/base/templateForm/detail',
  method: 'get',
  params: {
    ...params,
  },
})

const formPage = (current, size, params) => request({
  url: '/api/mcc-base/base/templateForm/formPage',
  method: 'get',
  params: {
    ...params,
    current,
    size,
  },
})

export default {
  getList,
  detail,
  formDetail,
  formPage,
};
